import { Component } from '@angular/core'
import { NotificationService } from "../../services/notification.service";
import { finegrainedService } from "../FineGrainedAuthorization/finegrained.service";
import { ProjectRequest } from './project-request';
import { ProjectActivityRequest } from './project-activity-request';

@Component({
    selector: 'finegrained',
    template: require('./finegrained.component.html')
})

export class finegrainedComponent {

    showParentProject: boolean;
    projectName: string;
    parentProjectName: string;
    projectAction: string;
    hasProjectDetails: boolean;
    hasProjectActivityDetails: boolean;
    private projectDetails: ProjectDetails;
    projects: string[];
    responseData: any;
    tagName: string;
    hasTags: boolean;
    private projectTags: ProjectTags;
    tagsList: string[];
    private activityDetails: ActivityDetails;
    activities: string[];
    activityName: string;


    constructor(private fineGrainedService: finegrainedService,
        private notifier: NotificationService) {
        this.projectName = null;
        this.tagName = null;
        this.notifier.clear();
    }

    clearMessages() {
        this.hasProjectDetails = false;
        this.hasProjectActivityDetails = false;
        this.hasTags = false;
        this.notifier.clear();
    }

    fetchProject() {        

        this.hasProjectDetails = false;
        this.hasTags = false;

        if (this.projectName == null || this.projectName == undefined || this.projectName.length == 0) {
            this.notifier.displayError("Please enter with a valid project name.");
            return;
        }
            
        this.notifier.displayInfo("Attempting to fetch Projects..");
        this.fineGrainedService.getProjects(btoa(this.projectName)).subscribe(
            resp => {
                this.notifier.clear();
                this.projectDetails = resp.data;
                this.notifier.displaySuccess("Successfully fetched the projects.");
                this.projects = this.projectDetails.projectDetails.projects;
                if (this.projectDetails.statusCode === 200)
                    this.hasProjectDetails = true;

            },
            error => {
                this.notifier.clear();
                this.notifier.displayApiResponseError(error);
            });
    }

    initializeTab() {
        this.notifier.clear();
        this.hasProjectDetails = false;
        this.hasTags = false;
        this.tagName = null;
        this.hasProjectActivityDetails = false;
        this.activityName = null;
        this.parentProjectName = null;
    }

    deleteProject() {
        this.hasProjectDetails = false;
        this.hasTags = false;

        if (this.projectName == null || this.projectName == undefined || this.projectName.length == 0) {
            this.notifier.displayError("Please enter with a valid project name.");
            return;
        }
        this.notifier.displayInfo("Trying to delete project..");
        this.fineGrainedService.deleteProject(btoa(this.projectName)).subscribe(
            resp => {
                this.notifier.clear();
                this.responseData = resp;
                this.notifier.displaySuccess("Successfully deleted the project.");
            },
            error => {
                this.notifier.clear();
                this.notifier.displayApiResponseError(error);
            });
    }

    addProject() {

        this.hasProjectDetails = false;
        this.hasTags = false;

        if (this.projectName == null || this.projectName == undefined || this.projectName.length == 0) {
            this.notifier.displayError("Please enter with a valid project name.");
            return;
        }

        if (this.parentProjectName == null || this.parentProjectName == undefined || this.parentProjectName.length == 0) {
            this.notifier.displayError("Please enter with a valid parent project name.");
            return;
        }

        this.notifier.displayInfo("Attempting to add project.");
        var projectRequest = new ProjectRequest(this.parentProjectName,
           this.projectName);
        this.fineGrainedService.addProject(projectRequest).subscribe(
            resp => {
                this.notifier.clear();
                this.notifier.displaySuccess("Successfully created project.");
                this.responseData = resp;               

            },
            error => {
                this.notifier.clear();
                this.notifier.displayApiResponseError(error);
            });
    }

    fetchProjectActivities() {

        this.hasProjectDetails = false;
        if (this.projectName == null || this.projectName == undefined || this.projectName.length == 0) {
            this.notifier.displayError("Please enter with a valid project name.");
            return;
        }

        this.notifier.displayInfo("Attempting to fetch project activity.");
        this.fineGrainedService.getProjectActivities(btoa(this.projectName)).subscribe(
            resp => {
                this.notifier.clear();
                this.activityDetails = resp.data;
                this.notifier.displaySuccess("Successfully fetched the project activities.");
                this.activities = this.activityDetails.activities;
                if (this.activityDetails.statusCode === 200)
                    this.hasProjectActivityDetails = true;

            },
            error => {
                this.notifier.clear();
                this.notifier.displayApiResponseError(error);
            });
    }


    addProjectActivity() {

        this.hasProjectActivityDetails = false;
        if (this.projectName == null || this.projectName == undefined || this.projectName.length == 0) {
            this.notifier.displayError("Please enter with a valid project name.");
            return;
        }

        if (this.activityName == null || this.activityName == undefined || this.activityName.length == 0) {
            this.notifier.displayError("Please enter with a valid activity name.");
            return;
        }

        this.notifier.displayInfo("Attempting to add activity.");
        var projectActivityRequest = new ProjectActivityRequest(
            this.projectName, this.activityName);
        this.fineGrainedService.addProjectActivity(projectActivityRequest).subscribe(
            resp => {
                this.notifier.clear();
                this.notifier.displaySuccess("Successfully created activity.");
                this.responseData = resp;

            },
            error => {
                this.notifier.clear();
                this.notifier.displayApiResponseError(error);
            });
    }

    deleteProjectActivity() {
        if (this.activityName == null || this.activityName == undefined || this.activityName.length == 0) {
            this.notifier.displayError("Please enter with a valid activity.");
            return;
        }
        this.notifier.displayInfo("Trying to delete activity..");
        var projectActivityRequest = new ProjectActivityRequest(
            btoa(this.projectName), this.activityName);
        this.fineGrainedService.deleteProjectActivity(projectActivityRequest).subscribe(
            resp => {
                this.notifier.clear();
                this.responseData = resp;
                this.notifier.displaySuccess("Successfully deleted the project activity.");
            },
            error => {
                this.notifier.clear();
                this.notifier.displayApiResponseError(error);
            });
    }

    addTag() {

        this.hasProjectDetails = false;
        this.hasTags = false;

        if (this.projectName == null || this.projectName == undefined || this.projectName.length == 0) {
            this.notifier.displayError("Please enter with a valid project name.");
            return;
        }

        if (this.tagName == null || this.tagName == undefined || this.tagName.length == 0) {
            this.notifier.displayError("Please enter with a valid project tag name.");
            return;
        }

        this.notifier.displayInfo("Attempting to add project tag..");

        this.fineGrainedService.addProjectTag(this.projectName, this.tagName).subscribe(
            resp => {
                this.notifier.clear();
                this.notifier.displaySuccess("Successfully created project tag.");
                this.responseData = resp;

            },
            error => {
                this.notifier.clear();
                this.notifier.displayApiResponseError(error);
            });
    }


    deleteTag() {

        this.hasProjectDetails = false;
        this.hasTags = false;

        if (this.projectName == null || this.projectName == undefined || this.projectName.length == 0) {
            this.notifier.displayError("Please enter with a valid project name.");
            return;
        }
        if (this.tagName == null || this.tagName == undefined || this.tagName.length == 0) {
            this.notifier.displayError("Please enter with a valid project tag name.");
            return;
        }

        this.notifier.displayInfo("Attempting to delete  project tag..");

        this.fineGrainedService.deleteProjectTag(btoa(this.projectName), this.tagName).subscribe(
            resp => {
                this.notifier.clear();
                this.notifier.displaySuccess("Successfully deleted project tag.");
                this.responseData = resp;

            },
            error => {
                this.notifier.clear();
                this.notifier.displayApiResponseError(error);
            });
    }

    fetchTags() {

        this.hasProjectDetails = false;
        this.hasTags = false;

        if (this.projectName == null || this.projectName == undefined || this.projectName.length == 0) {
            this.notifier.displayError("Please enter with a valid project name.");
            return;
        }

        this.notifier.displayInfo("Attempting to fetch tags...");
        this.fineGrainedService.getProjectTags(btoa(this.projectName)).subscribe(
            resp => {
                this.notifier.clear();
                this.projectTags = resp.data;
                this.notifier.displaySuccess("Successfully fetched project tags.");
                this.tagsList = this.projectTags.projectTags.tags;
                if (this.projectTags.statusCode === 200)
                    this.hasTags = true;

            },
            error => {
                this.notifier.clear();
                this.notifier.displayApiResponseError(error);
            });
    }

}

interface ProjectDetails {
    statusCode: number;
    projectDetails: Project;
}

interface Project {
    projects: string[];
}

interface ActivityDetails {
    statusCode: number;
    activities: string[];
}


interface ProjectTags {
    statusCode: number;
    projectTags: Tags;
}

interface Tags {
    tags: string[];
}





/** WEBPACK FOOTER **
 ** ./F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/main/FineGrainedAuthorization/finegrained.component.ts
 **/